const ALL_FIELDS = [
  { label: (type) => (type === 'sale' ? 'Bill To' : 'Supplier'), key: 'supplier', type: 'text' },
  { label: () => 'Address', key: 'address', type: 'text', saleField: false },
  { label: () => 'Phone', key: 'phone', type: 'tel', saleField: false },
  { label: () => 'Email', key: 'email', type: 'email', saleField: false },
  { label: () => 'Invoice No.', key: 'invoiceNo', type: 'text' },
  { label: () => 'Invoice Date', key: 'date', type: 'date' },
  { label: () => 'Due Date', key: 'dueDate', type: 'date', saleField: false },
  { label: () => 'PO Number', key: 'poNumber', type: 'text', saleField: false },
];

export default function InvoiceMetaGridEditable({ type, invoice, onChange }) {
  const FIELDS = ALL_FIELDS.filter(f => type !== 'sale' || f.saleField !== false);
  return (
    <div style={{ padding: '20px 32px 0' }}>
      <div className="meta-section">
        {FIELDS.map(f => (
          <div className="meta-cell" key={f.key}>
            <div className="meta-label">{f.label(type)}</div>
            <input
              className="meta-input"
              type={f.type}
              value={invoice[f.key] || ''}
              onChange={e => onChange(f.key, e.target.value)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
